var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "starter-page", on: { dblclick: _vm.handleDblClick } },
    [
      _c(
        "div",
        {
          staticClass:
            "navbar-dark project-header px-4 py-2 d-flex justify-content-between",
        },
        [
          _c("div", { staticClass: "gantt-title-wrapper" }, [
            _vm.query && Object.keys(_vm.query).length == 0 && false
              ? _c(
                  "span",
                  {
                    staticClass:
                      "align-middle ticket-title__client-name pl-0 project-home",
                  },
                  [_vm._v(_vm._s(_vm.demoText) + " Projects")]
                )
              : _vm._e(),
            _vm.query && Object.keys(_vm.query).length > 0 && _vm.searchResults
              ? _c(
                  "span",
                  {
                    staticClass:
                      "align-middle ticket-title__client-name pl-0 project-home",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.searchResults && _vm.searchResults.data.length
                        ) +
                        "\n        "
                    ),
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.searchResults.data.length > 1
                              ? "Projects"
                              : "Project"
                          ) +
                          " "
                      ),
                    ]),
                    _vm._v("found " + _vm._s(_vm.q ? ". For " + _vm.q : "")),
                  ]
                )
              : _vm._e(),
          ]),
          false
            ? _c("div", { staticClass: "d-flex align-items-center" }, [
                _vm.profile &&
                _vm.profile.role &&
                _vm.profile.role.name != "guest"
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm text-white bg-info my-2 mt-2 mb-2 ml-2 my-md-0",
                        attrs: {
                          type: "button",
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({ name: "timesheet.home" })
                          },
                        },
                      },
                      [_vm._v("\n        My Timesheet\n      ")]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _vm.query &&
      (Object.keys(_vm.query).length == 0 ||
        Object.keys(_vm.query).some((q) => q == "redirect" || q == "login")) &&
      _vm.projects &&
      _vm.profile
        ? _c("Gantt", {
            attrs: {
              tasks: _vm.projects,
              currency: _vm.profile.currency,
              enableResize: false,
              ganttView: _vm.profile.ganttViewMode,
              ganttDay: _vm.profile.ganttDayMode,
              ganttComment: _vm.ganttCommentMode,
              ganttZoom: _vm.profile.ganttZoomMode,
              showBilling: _vm.profile.showFinance == "1",
              "color-class": "",
            },
            on: {
              dblClickEmptyArea: _vm.handleTaskDblClick,
              "task-link-clicked": _vm.handleProjectLinkClick,
              "task-dbl-click": _vm.handleTaskDblClick,
              "task-dragged": _vm.handleTaskDragged,
              "assigned-by-user-clicked": _vm.handleAssignedByUserClicked,
              "assigned-to-user-clicked": _vm.handleAssignedToUserClicked,
            },
          })
        : _vm._e(),
      _vm.query &&
      Object.keys(_vm.query).length > 0 &&
      !Object.keys(_vm.query).some((q) => q == "redirect" || q == "login") &&
      _vm.searchResults &&
      _vm.profile
        ? _c("Gantt", {
            attrs: {
              tasks: _vm.searchResults,
              currency: _vm.profile.currency,
              ganttView: _vm.profile.ganttViewMode,
              ganttDay: _vm.profile.ganttDayMode,
              ganttComment: _vm.ganttCommentMode,
              ganttZoom: _vm.profile.ganttZoomMode,
              enableResize: false,
              showBilling: _vm.profile.showFinance == "1",
              "color-class": "",
            },
            on: {
              dblClickEmptyArea: _vm.handleTaskDblClick,
              "task-link-clicked": _vm.handleProjectLinkClick,
              "task-dbl-click": _vm.handleTaskDblClick,
              "task-dragged": _vm.handleTaskDragged,
              "assigned-by-user-clicked": _vm.handleAssignedByUserClicked,
              "assigned-to-user-clicked": _vm.handleAssignedToUserClicked,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }